import { render, staticRenderFns } from "./system_management_banner.vue?vue&type=template&id=c9df3c96&scoped=true&"
import script from "./system_management_banner.vue?vue&type=script&lang=js&"
export * from "./system_management_banner.vue?vue&type=script&lang=js&"
import style0 from "./system_management_banner.vue?vue&type=style&index=0&id=c9df3c96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9df3c96",
  null
  
)

export default component.exports